'use client';
import React from 'react';
import { useState } from 'react';
// import { Link } from 'react-router-dom'; // Use react-router-dom for routing
// import teamDetailsImg from '../../assets/images/team/team-details-img-1.jpg';


const FaqMain = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <React.Fragment>
          {/*FAQ One Start*/}
          <section className="faq-page">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="faq-page__left">
                    <div
                      className="accrodion-grp faq-one-accrodion"
                      data-grp-name="faq-one-accrodion-1"
                    >
                      {[
                        {
                          question: "What types of promotional products do you offer?",
                          answer:
                            "We offer a wide range of promotional products including custom apparel, drinkware, tech accessories, office supplies, trade show items, and corporate gifts. With over 1,000 product options, we can help you find the perfect items for your brand.",
                        },
                        {
                          question: "What is your minimum order quantity?",
                          answer:
                            "Minimum order quantities vary by product. Many items start at 25 pieces, while some specialty items may require higher minimums. Contact us for specific requirements on your desired products.",
                        },
                        {
                          question: "How long does production take?",
                          answer:
                            "Standard production time is typically 7-10 business days after artwork approval. Rush orders are available for many items with faster turnaround times. Production time varies by product complexity and quantity.",
                        },
                        {
                          question: "Do you provide artwork and design services?",
                          answer:
                            "Yes! Our design team can help create artwork for your promotional products. We also accept customer-provided artwork in various formats including AI, EPS, PDF, and high-resolution PNG files.",
                        },
                      ].map((item, index) => (
                        <div
                          className={`accrodion ${
                            activeIndex === index ? "active" : ""
                          }`}
                          key={index}
                        >
                          <div
                            className="accrodion-title"
                            onClick={() => toggleAccordion(index)}
                          >
                            <h4>{item.question}</h4>
                            <div className="faq-one-accrodion__count"></div>
                          </div>
                          {activeIndex === index && (
                            <div className="accrodion-content">
                              <div className="inner">
                                <p>{item.answer}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="faq-page__right">
                    <div
                      className="accrodion-grp faq-one-accrodion"
                      data-grp-name="faq-one-accrodion-2"
                    >
                      {[
                        {
                          question: "What types of promotional products do you offer?",
                          answer:
                            "We offer a wide range of promotional products including custom apparel, drinkware, tech accessories, office supplies, trade show items, and corporate gifts. With over 1,000 product options, we can help you find the perfect items for your brand.",
                        },
                        {
                          question: "What is your minimum order quantity?",
                          answer:
                            "Minimum order quantities vary by product. Many items start at 25 pieces, while some specialty items may require higher minimums. Contact us for specific requirements on your desired products.",
                        },
                        {
                          question: "How long does production take?",
                          answer:
                            "Standard production time is typically 7-10 business days after artwork approval. Rush orders are available for many items with faster turnaround times. Production time varies by product complexity and quantity.",
                        },
                        {
                          question: "Do you provide artwork and design services?",
                          answer:
                            "Yes! Our design team can help create artwork for your promotional products. We also accept customer-provided artwork in various formats including AI, EPS, PDF, and high-resolution PNG files.",
                        },
                      ].map((item, index) => (
                        <div
                          className={`accrodion ${
                            activeIndex === index + 4 ? "active" : ""
                          }`}
                          key={index + 4}
                        >
                          <div
                            className="accrodion-title"
                            onClick={() => toggleAccordion(index + 4)}
                          >
                            <h4>{item.question}</h4>
                            <div className="faq-one-accrodion__count"></div>
                          </div>
                          {activeIndex === index + 4 && (
                            <div className="accrodion-content">
                              <div className="inner">
                                <p>{item.answer}</p>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/*FAQ One End*/}
        </React.Fragment>
    );
};

export default FaqMain;
